var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"label":"Spinning"}}),_vm._v("\n        Loading...\n      ")],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }